import i18n from '@/lang/i18n'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.tc('configuration.sections.incidentOrigins', 1),
            colId: 'nameTranslationKey',
            field: 'name',
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.description'),
            colId: 'descriptionTranslationKey',
            field: 'description',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: 'flagsRenderer',
            headerName: i18n.t('configuration.grid.incidentsOriginTranslations'),
            colId: 'nameTranslations',
            field: 'nameTranslations',
            minWidth: 200,
            filter: false,
            sortable: false,
            flex: 2
        },
        {
            type: 'flagsRenderer',
            headerName: i18n.t('configuration.grid.descriptionTranslations'),
            colId: 'descriptionTranslations',
            field: 'descriptionTranslations',
            minWidth: 200,
            filter: false,
            sortable: false,
            flex: 2
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.system'),
            colId: 'systemDefined',
            field: 'systemDefined',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            colId: 'active',
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.phase'),
            colId: 'workPhase.nameTranslationKey',
            field: 'workPhase.name',
            width: 150,
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]
}
